import './App.css';
import OgaApp from './AppContainerComponent/OgaApp.Component/OgaApp';
import SecureMe from './AppContainerComponent/SecureMe.Component/SecureMe';
import SubscriberUtilities from './AppContainerComponent/SubscriberUtilities';
import Footer from './FooterComponent/footer';
import Hero from './HeroSection/Hero';
import HomePage from './HomePageComponents/HomePage';
import NavBar from "./NavBarComponent/NavBar";
import BuyAirtime from './userDashboard/buyAirtime/buyAirtime';
import DataBundle from './userDashboard/buydata/buydata';
import UserDashboard from './userDashboard/userDashboard';
import Login from './UserSignUp/Login/Login';
import { Routes, Route } from "react-router-dom";
import AutoLogout from './utilities/logout';
import BorrowAirtimeData from './userDashboard/borrowAirtime';
import ShareAirtimeData from './userDashboard/shareAirtimeData';
import UserProfile from './userDashboard/profile';
import SubscribersWallet from './userDashboard/wallet/wallet';
import TopupHistory from './userDashboard/topupHistory/topupHistory';
import ReservedNumbers from './userDashboard/ReserveNumbers/ReservedNumbers';
import XphoneActivationForm from './userDashboard/XphoneActivationForm';
import ReservedNumbersNew from './userDashboard/reservedNumbers/reservedNumbers';
import TransactionHistory from './userDashboard/TransactionHistory/TransactionHistory';
import XphoneBundles from './userDashboard/XphoneBundles';
import LoginOtp from './UserSignUp/loginOtp';
import NotFoundPage from './HomePageComponents/404page/404page';
import Page404 from './404Page/Page404';

function App() {
  return (
    <div className='App'>
      <Routes>
        {/* Public route (excluded from AutoLogout) */}
        {/* <Route path='/' element={<Login />} /> */}
        <Route path='/' element={<Page404 />} />
        {/* <Route path='*' element={<NotFoundPage />} />
         <Route path='login-otp' element={<LoginOtp />} />
       
        <Route path='/secureme' element={<AutoLogout><SecureMe /></AutoLogout>} />
        <Route path='/oga-app' element={<AutoLogout><OgaApp /></AutoLogout>} />
        <Route path='/buy-airtime' element={<AutoLogout><BuyAirtime /></AutoLogout>} />
        <Route path='/buy-data' element={<AutoLogout><DataBundle /></AutoLogout>} />
        <Route path='/borrow-airtime-data' element={<AutoLogout><BorrowAirtimeData /></AutoLogout>} />
        <Route path='/share-airtime-data' element={<AutoLogout><ShareAirtimeData /></AutoLogout>} />
        <Route path='/user-dashboard' element={<AutoLogout><UserDashboard /></AutoLogout>} />
        <Route path='/user-profile' element={<AutoLogout><UserProfile /></AutoLogout>} />
        <Route path='/topup-history' element={<AutoLogout><TopupHistory /></AutoLogout>} />
        <Route path='/transaction-history' element={<AutoLogout><TransactionHistory /></AutoLogout>} />
        <Route path='/reserved-numbers' element={<AutoLogout><ReservedNumbersNew /></AutoLogout>} />
        <Route path='/activate-xphone' element={<AutoLogout><XphoneActivationForm /></AutoLogout>} />
        <Route path='/xphone-bundle' element={<AutoLogout><XphoneBundles /></AutoLogout>} />
        <Route path='/subscriber-wallet' element={<AutoLogout><SubscribersWallet /></AutoLogout>} /> */}
      </Routes>
    </div>
  );
}

export default App;
